import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as authAction from '../../../actions/authAction';
import _, { clamp } from 'lodash';
import * as HELPER from '../../../utils/helpers';
import DataGrid from '../../../components/DataGrid';
import moment from "moment";

class DialysisTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    columns = () => {
        return [
            {
                dataField: 'date',
                text: 'Date',
                formatter:this.dateFormatter,
            },{
                dataField: 'doctor_name',
                text: 'Doctor Name'
            }, {
                dataField: 'machine_room_no',
                text: 'Machine Room No'
            }, {
                dataField: 'time_on',
                text: 'Time On',
                formatter: this.timeFormatter,
            }, {
                dataField: 'time_off',
                text: 'Time Off',
                formatter: this.timeFormatter,
            }, {
                dataField: 'created_at',
                formatter: this.dateFormatterCreated,
                text: 'Created On'
            }, {
                formatter: this.actionFormatter,
                text: 'Actions',
                hidden: this.props.hideActions
            }]
    }

    timeFormatter = (cell) => {
        return cell ? moment(cell).format('HH:mm') : '';
      }

    actionFormatter = (cell, row) => {
        return <Link to={`/patients/` + this.props.patientId + `/dialysis/${row.id}`}  className="view-link"><i className="view-icon-icon"></i><span className="view-text">
        View
      </span></Link>
    }

    dateFormatter = (cell, row) => {
        if (row) {
            return HELPER.getDateFormat(row.date)
        }
    }

    dateFormatterCreated = (cell, row) => {
        if (row) {
            return HELPER.getDateFormat(row.created_at)
        }
    }

    componentDidMount() {
        this.props.getDialysisList(this.props.patientId, {})
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "search") {
            page = 1;
        }

        this.props.getDialysisList(this.props.patientId, { page, sizePerPage, sortBy: { sortField, sortOrder } });
    };

    render() {
        const { successResponse } = this.props.dialysislist;
        return (
            <>
            <style>
                {`
                    .view-link {
                    display: inline-flex;
                    align-items: center;
                    text-decoration: none;
                    color: inherit;
                    }

                    .view-icon-icon {
                    font-size: 1rem; /* adjust size if needed */
                    margin-right: 5px;
                    }

                    .view-text {
                    display: inline-block;
                    vertical-align: middle;
                    }

                `}
            </style>
            <DataGrid
                columns={this.columns()}
                data={successResponse.data}
                meta={successResponse.meta}
                handleTableChange={this.handleTableChange}
                noDataIndication="No Record Found" />
            </>
        )
    }
}
const mapStateToProps = (state) => ({
    user: state.session.user,
    authenticated: state.session.authenticated,
    dialysislist: state.dialysislist
});

const mapActionsToProps = ({
    getDialysisList: authAction.getDialysisList
})

export default connect(mapStateToProps, mapActionsToProps)(DialysisTable);
